// [NUXIBA]  Version: 0.0.5 - 2022-09-27 10:00:42  
 (function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["EntryPoint"] = factory();
	else
		root["EntryPoint"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.UtilityFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ExternalLibrary = __webpack_require__(1);

var _URLClient = __webpack_require__(4);

var _URLWrapper = __webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UtilityFactory = exports.UtilityFactory = function () {
	function UtilityFactory() {
		_classCallCheck(this, UtilityFactory);
	}

	_createClass(UtilityFactory, [{
		key: 'buildClient',
		value: function buildClient(document, route) {
			return new _ExternalLibrary.ExternalLibrary(document, route);
		}
	}, {
		key: 'buildURLClient',
		value: function buildURLClient() {
			var urlWrapper = new _URLWrapper.URLWrapper();
			return new _URLClient.URLClient(urlWrapper);
		}
	}]);

	return UtilityFactory;
}();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalLibrary = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Logger = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExternalLibrary = exports.ExternalLibrary = function () {
  function ExternalLibrary(document, route) {
    _classCallCheck(this, ExternalLibrary);

    this.document = document;
    if (route === undefined || route === '') {
      _Logger.Logger.Error("Parameter route is empty");
    } else {
      this.loadLibrary(route);
    }
  }

  _createClass(ExternalLibrary, [{
    key: "loadLibrary",
    value: function loadLibrary(route) {
      _Logger.Logger.Debug("Loading js route:", route);
      this.document.write('<script type="text/javascript" src="' + route + '"></script>');
    }
  }]);

  return ExternalLibrary;
}();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Logger = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _globalLoggerServicesJsBundle = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

_globalLoggerServicesJsBundle.LoggerInstance.setApplication('[Common-Utilities]');

var Logger = exports.Logger = function () {
	function Logger() {
		_classCallCheck(this, Logger);
	}

	_createClass(Logger, [{
		key: 'setUserType',
		value: function setUserType(userType) {
			Logger.setUserType(userType);
		}
	}], [{
		key: 'setUserId',
		value: function setUserId(userId) {
			_globalLoggerServicesJsBundle.LoggerInstance.setUserId(userId);
		}
	}, {
		key: 'Trace',
		value: function Trace() {
			for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
				msg[_key] = arguments[_key];
			}

			_globalLoggerServicesJsBundle.LoggerInstance.Trace(['[Common-Utilities]'].concat(msg));
		}
	}, {
		key: 'Debug',
		value: function Debug() {
			for (var _len2 = arguments.length, msg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				msg[_key2] = arguments[_key2];
			}

			_globalLoggerServicesJsBundle.LoggerInstance.Debug(['[Common-Utilities]'].concat(msg));
		}
	}, {
		key: 'Warning',
		value: function Warning() {
			for (var _len3 = arguments.length, msg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
				msg[_key3] = arguments[_key3];
			}

			_globalLoggerServicesJsBundle.LoggerInstance.Warning(['[Common-Utilities]'].concat(msg));
		}
	}, {
		key: 'Info',
		value: function Info() {
			for (var _len4 = arguments.length, msg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
				msg[_key4] = arguments[_key4];
			}

			_globalLoggerServicesJsBundle.LoggerInstance.Info(['[Common-Utilities]'].concat(msg));
		}
	}, {
		key: 'Error',
		value: function Error() {
			for (var _len5 = arguments.length, msg = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
				msg[_key5] = arguments[_key5];
			}

			_globalLoggerServicesJsBundle.LoggerInstance.Error(['[Common-Utilities]'].concat(msg));
		}
	}]);

	return Logger;
}();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// [NUXIBA]  Version: 2021.4.2 - 2022-07-29 14:37:32  
 (function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["LoggerEntryPoint"] = factory();
	else
		root["LoggerEntryPoint"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(5);
var isBuffer = __webpack_require__(15);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var instance = null;

var Constants = exports.Constants = function Constants() {
    _classCallCheck(this, Constants);

    if (!instance) {
        instance = this;
    }
};

Constants._LOGGER_VAR_WINDOW = "NuxibaLogger";
Constants._LOGGER_CONFIGURATION_FILE_LOCALE = './logger.json';
Constants._LOGGER_CONFIGURATION_FILE_REMOTE = 'logger.json';
Constants._LOGGER_CONFIGURATION_FILE_ENCODE = 'utf8';
Constants._LOGGER_CONFIGURATION_ASSIGNED = window[Constants._LOGGER_VAR_WINDOW] ? true : false;
Constants._LOG_LEVELS = {
    "TRACE": { logLevel: 0 },
    "DEBUG": { logLevel: 1 },
    "INFO": { logLevel: 2 },
    "WARN": { logLevel: 3 },
    "ERROR": { logLevel: 4 }
};
Constants._Log_CONSOLE = {
    "TRACE": console.log,
    "DEBUG": console.log,
    "INFO": console.info,
    "WARN": console.warn,
    "ERROR": console.error
};
Constants._CONFIGURATIONS = {
    "_ENABLE_DEFAULT": true,
    "_ENABLE_AJAX": false,
    "_USE_WINDOW_ORIGIN": true,
    "_SERVER": "http://127.0.0.1",
    "_DOMAIN": "/LoggerWS/api/Logger",
    "_SEVERITY": "INFO",
    "_SEVERITY_CONSOLE": "INFO",
    "_NUMBER_ATTEMP_POST": 10,
    "_FILTER_USER_POST": [],
    "_FILTER_APP_POST": []
};
Constants._REST = {
    _POST_METHOD: "POST",
    _MODE: "cors",
    _CONTENT_TYPE: "content-type",
    _APPLICATION_JSON: "application/json"
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(0);
var normalizeHeaderName = __webpack_require__(18);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(6);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(6);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LoggerInstance = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LoggerDispatcher = __webpack_require__(12);

var _Constants = __webpack_require__(1);

var _LoggerLocal = __webpack_require__(11);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var usertype = 'AGENT';
var userId = "";
var application = "";

var LoggerInstance = function () {
	function LoggerInstance() {
		_classCallCheck(this, LoggerInstance);
	}

	_createClass(LoggerInstance, null, [{
		key: 'setUsertype',
		value: function setUsertype(value) {
			usertype = value;
		}
	}, {
		key: 'setUserId',
		value: function setUserId(value) {
			userId = value;
		}
	}, {
		key: 'getUserId',
		value: function getUserId() {
			return userId;
		}
	}, {
		key: 'setApplication',
		value: function setApplication(value) {
			application = value;
		}
	}, {
		key: 'setLocalLogger',
		value: function setLocalLogger(value) {
			_LoggerLocal.LoggerLocal.setEnabled(value);
		}
	}, {
		key: 'setLocalStorageTime',
		value: function setLocalStorageTime(minutes) {
			_LoggerLocal.LoggerLocal.setStorageTimeMin(minutes);
		}
	}, {
		key: 'getApplication',
		value: function getApplication() {
			return application;
		}
	}, {
		key: 'SetUseServerWithLocation',
		value: function SetUseServerWithLocation(useWindowLocation) {
			window[_Constants.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_LOCATION = useWindowLocation;
		}
	}, {
		key: 'addUserId',
		value: function addUserId(msg) {
			if (userId) {
				var userIdPrint = '[UserId:' + userId + ']';
				msg.unshift(userIdPrint);
			}
		}
	}, {
		key: 'Group',
		value: function Group(label) {
			console.group(label);
		}
	}, {
		key: 'GroupEnd',
		value: function GroupEnd() {
			console.groupEnd();
		}
	}, {
		key: 'CleanLocalLog',
		value: function CleanLocalLog() {
			_LoggerLocal.LoggerLocal.Clean();
		}
	}, {
		key: 'Trace',
		value: function Trace() {
			for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
				msg[_key] = arguments[_key];
			}

			_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Trace', ['[UserId:' + userId + ']'].concat(msg));
		}
	}, {
		key: 'Debug',
		value: function Debug() {
			for (var _len2 = arguments.length, msg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				msg[_key2] = arguments[_key2];
			}

			LoggerInstance.addUserId(msg);
			_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Debug', ['[UserId:' + userId + ']'].concat(msg));
		}
	}, {
		key: 'Warning',
		value: function Warning() {
			for (var _len3 = arguments.length, msg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
				msg[_key3] = arguments[_key3];
			}

			LoggerInstance.addUserId(msg);
			_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Warn', ['[UserId:' + userId + ']'].concat(msg));
		}
	}, {
		key: 'Warn',
		value: function Warn() {
			for (var _len4 = arguments.length, msg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
				msg[_key4] = arguments[_key4];
			}

			LoggerInstance.Warning(msg);
		}
	}, {
		key: 'Info',
		value: function Info() {
			for (var _len5 = arguments.length, msg = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
				msg[_key5] = arguments[_key5];
			}

			LoggerInstance.addUserId(msg);
			_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Info', ['[UserId:' + userId + ']'].concat(msg));
		}
	}, {
		key: 'Error',
		value: function Error() {
			for (var _len6 = arguments.length, msg = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
				msg[_key6] = arguments[_key6];
			}

			LoggerInstance.addUserId(msg);
			_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Error', ['[UserId:' + userId + ']'].concat(msg));
		}
	}, {
		key: 'JsWarning',
		value: function JsWarning() {
			for (var _len7 = arguments.length, msg = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
				msg[_key7] = arguments[_key7];
			}

			LoggerInstance.addUserId(msg);
			_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Warn', ['[UserId:' + userId + ']'].concat(msg), true);
		}
	}, {
		key: 'JsError',
		value: function JsError() {
			for (var _len8 = arguments.length, msg = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
				msg[_key8] = arguments[_key8];
			}

			LoggerInstance.addUserId(msg);
			_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Error', ['[UserId:' + userId + ']'].concat(msg), true);
		}
	}, {
		key: 'LevelConsole',
		get: function get() {
			return window[_Constants.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE;
		}
	}]);

	return LoggerInstance;
}();

exports.LoggerInstance = LoggerInstance;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(14);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var settle = __webpack_require__(19);
var buildURL = __webpack_require__(21);
var parseHeaders = __webpack_require__(22);
var isURLSameOrigin = __webpack_require__(23);
var createError = __webpack_require__(7);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(24);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(20);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggerUtils = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Constants = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoggerUtils = function () {
  function LoggerUtils() {
    _classCallCheck(this, LoggerUtils);
  }

  _createClass(LoggerUtils, null, [{
    key: "GetLogLevelBySeverity",
    value: function GetLogLevelBySeverity(severity) {
      var logLevel = 1;
      severity = severity.toUpperCase();
      if (_Constants.Constants._LOG_LEVELS[severity]) {
        logLevel = _Constants.Constants._LOG_LEVELS[severity].logLevel;
      }
      return logLevel;
    }
  }, {
    key: "IsAllowedRemoteToLogBySeverity",
    value: function IsAllowedRemoteToLogBySeverity(severity) {
      return LoggerUtils.GetLogLevelBySeverity(severity) >= LoggerUtils.GetCurrentRemoteSeverityLevelConfigured();
    }
  }, {
    key: "GetCurrentRemoteSeverityLevelConfigured",
    value: function GetCurrentRemoteSeverityLevelConfigured() {
      return LoggerUtils.GetLogLevelBySeverity(window[_Constants.Constants._LOGGER_VAR_WINDOW]["_SEVERITY"]);
    }
  }, {
    key: "IsAllowedConsoleToLogBySeverity",
    value: function IsAllowedConsoleToLogBySeverity(severity) {
      return LoggerUtils.GetLogLevelBySeverity(severity) >= LoggerUtils.GetCurrentConsoleSeverityLevelConfigured();
    }
  }, {
    key: "GetCurrentConsoleSeverityLevelConfigured",
    value: function GetCurrentConsoleSeverityLevelConfigured() {
      return LoggerUtils.GetLogLevelBySeverity(window[_Constants.Constants._LOGGER_VAR_WINDOW]["_SEVERITY_CONSOLE"]);
    }
  }, {
    key: "ToStringMessage",
    value: function ToStringMessage() {
      var messageString = "";

      for (var _len = arguments.length, message = Array(_len), _key = 0; _key < _len; _key++) {
        message[_key] = arguments[_key];
      }

      message.forEach(function (entry) {
        messageString += LoggerUtils.ToStringObject(entry);
      });
      return messageString;
    }
  }, {
    key: "ToStringObject",
    value: function ToStringObject(entry) {
      return LoggerUtils.IsObject(entry) ? '\n' + LoggerUtils.JsonToString(entry) : entry;
    }
  }, {
    key: "IsObject",
    value: function IsObject(value) {
      return value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && value.constructor === Object;
    }
  }, {
    key: "JsonToString",
    value: function JsonToString(entry) {
      var seen = [];
      var jsonString = JSON.stringify(entry, function (key, val) {
        if (val && (typeof val === "undefined" ? "undefined" : _typeof(val)) == "object") {
          seen.push(val);
        }
        return val;
      }, 2);

      return jsonString;
    }
  }]);

  return LoggerUtils;
}();

exports.LoggerUtils = LoggerUtils;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ls = window.localStorage;
var logKey = "LOG-" + new Date().getDate() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear();
var logDateKey = "GalateaLoggerDate";
var enabled = false;
var storageTimeMin = 0;
var firstLogTs = null;

var LoggerLocal = function () {
    function LoggerLocal() {
        _classCallCheck(this, LoggerLocal);
    }

    _createClass(LoggerLocal, null, [{
        key: "getKey",
        value: function getKey() {
            return logKey;
        }
    }, {
        key: "setEnabled",
        value: function setEnabled(value) {
            enabled = value;
        }
    }, {
        key: "setStorageTimeMin",
        value: function setStorageTimeMin(minutes) {
            storageTimeMin = minutes;
        }
    }, {
        key: "Add",
        value: function Add(message, usertype, severity) {
            if (enabled) {
                var ts = new Date();
                var prevEntries = ls.getItem(logKey);
                var newEntry = usertype + "-" + severity + " " + ts.getDate() + "-" + (ts.getMonth() + 1) + "-" + ts.getFullYear() + "-" + ts.getDate() + " " + ts.toLocaleTimeString() + " - MSG: " + message;
                if (prevEntries) {
                    if (!firstLogTs) {
                        firstLogTs = new Date(JSON.parse(ls.getItem(logDateKey)));
                    }
                    if (storageTimeMin !== 0 && (ts - firstLogTs) / 60000 > storageTimeMin) {
                        LoggerLocal.Clean();
                        firstLogTs = ts;
                        ls.setItem(logDateKey, JSON.stringify(ts));
                    } else {
                        newEntry = prevEntries + ";" + newEntry;
                    }
                    ls.setItem(logKey, "" + newEntry);
                } else {
                    firstLogTs = ts;
                    ls.setItem(logKey, newEntry);
                    ls.setItem(logDateKey, JSON.stringify(ts));
                }
            }
        }
    }, {
        key: "getRawLogs",
        value: function getRawLogs() {
            return ls.getItem(logKey);
        }
    }, {
        key: "getLogs",
        value: function getLogs() {
            return ls.getItem(logKey).replaceAll(';', '\n');
        }
    }, {
        key: "Clean",
        value: function Clean() {
            console.log("Cleaning local storage ", logKey);
            ls.removeItem(logKey);
        }
    }]);

    return LoggerLocal;
}();

exports.LoggerLocal = LoggerLocal;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LoggerDispatcher = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LoggerRestClient = __webpack_require__(13);

var _Constants = __webpack_require__(1);

var _LoggerUtils = __webpack_require__(10);

var _LoggerConfigurator = __webpack_require__(32);

var _LoggerInstance = __webpack_require__(3);

var _LoggerLocal = __webpack_require__(11);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ls = window.localStorage;

var LoggerDispatcher = function () {
	function LoggerDispatcher() {
		_classCallCheck(this, LoggerDispatcher);
	}

	_createClass(LoggerDispatcher, null, [{
		key: 'Dispatch',
		value: function Dispatch(usertype, severity, message, hideInConsole) {
			_LoggerLocal.LoggerLocal.Add(message, usertype, severity);
			_LoggerConfigurator.LoggerConfigurator.Init(function () {
				!hideInConsole && LoggerDispatcher.DefaultOutput.apply(LoggerDispatcher, [usertype, severity].concat(_toConsumableArray(message)));
				LoggerDispatcher.RemoteOutput.apply(LoggerDispatcher, [usertype, severity].concat(_toConsumableArray(message)));
			});
		}
	}, {
		key: 'RemoteOutput',
		value: function RemoteOutput(usertype, severity) {
			if (window[_Constants.Constants._LOGGER_VAR_WINDOW] && window[_Constants.Constants._LOGGER_VAR_WINDOW]['_ENABLE_AJAX'] && _LoggerUtils.LoggerUtils.IsAllowedRemoteToLogBySeverity(severity)) {
				for (var _len = arguments.length, message = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
					message[_key - 2] = arguments[_key];
				}

				if (severity.toUpperCase() === 'WARN' || severity.toUpperCase() === 'ERROR') {
					_LoggerRestClient.LoggerRestClient.log(usertype, severity, '[' + usertype + '] ' + message);
				} else {
					var isEmptyFilterUser = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.length === 0;
					var isEmptyFilterApp = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.length === 0;

					if (isEmptyFilterUser && isEmptyFilterApp) {
						_LoggerRestClient.LoggerRestClient.log.apply(_LoggerRestClient.LoggerRestClient, [usertype, severity].concat(message));
					} else {
						var containtUserId = true;
						var containtApp = true;

						if (!isEmptyFilterUser) {
							containtUserId = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.find(function (ele) {
								return ele === _LoggerInstance.LoggerInstance.getUserId();
							});
						}
						if (!isEmptyFilterApp) {
							containtApp = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.find(function (ele) {
								return ele === _LoggerInstance.LoggerInstance.getApplication();
							});
						}

						if (containtUserId && containtApp) {
							_LoggerRestClient.LoggerRestClient.log(usertype, severity, '[' + usertype + '] ' + message);
						}
					}
				}
			}
		}
	}, {
		key: 'DefaultOutput',
		value: function DefaultOutput(usertype, severity) {
			severity = severity.toUpperCase();
			if (window[_Constants.Constants._LOGGER_VAR_WINDOW] && window[_Constants.Constants._LOGGER_VAR_WINDOW]._ENABLE_DEFAULT && _LoggerUtils.LoggerUtils.IsAllowedConsoleToLogBySeverity(severity)) {
				var _consoleLogLevel;

				var consoleLogLevel = console.log;
				if (_Constants.Constants._Log_CONSOLE[severity]) {
					consoleLogLevel = _Constants.Constants._Log_CONSOLE[severity];
				}
				var time = new Date().toLocaleTimeString();

				for (var _len2 = arguments.length, message = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
					message[_key2 - 2] = arguments[_key2];
				}

				(_consoleLogLevel = consoleLogLevel).call.apply(_consoleLogLevel, [null, '[' + time + '][' + severity + '][' + usertype + ']'].concat(message));
			}
		}
	}]);

	return LoggerDispatcher;
}();

exports.LoggerDispatcher = LoggerDispatcher;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggerRestClient = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _Constants = __webpack_require__(1);

var _LoggerUtils = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var numberAttemp = 0;
var numMessageWarn = true;

var LoggerRestClient = function () {
  function LoggerRestClient() {
    _classCallCheck(this, LoggerRestClient);
  }

  _createClass(LoggerRestClient, null, [{
    key: 'log',
    value: function log(usertype, severity) {
      if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX) {
        if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST === 0 || numberAttemp < window[_Constants.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST) {
          try {
            var serverUrl = new URL(window[_Constants.Constants._LOGGER_VAR_WINDOW]["_SERVER"]);
            var server = new URL(window[_Constants.Constants._LOGGER_VAR_WINDOW]["_DOMAIN"], serverUrl);

            for (var _len = arguments.length, message = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
              message[_key - 2] = arguments[_key];
            }

            var msg = _LoggerUtils.LoggerUtils.ToStringMessage(message);
            _axios2.default.post(server, { UserType: usertype, Message: msg, Severity: severity }).then(function () {
              numberAttemp = 0;
            }).catch(function (error) {
              numberAttemp++;
              console.warn("It was not possible to send the message server:", server, error);
            });
          } catch (e) {
            numberAttemp++;
            console.error("it was not possible to send the log message because an error ocurred servidor:" + window[_Constants.Constants._LOGGER_VAR_WINDOW]["_SERVER"] + " error:" + e + " recommendation: you could check the logger configuration");
          }
        } else {
          if (numMessageWarn) {
            numMessageWarn = false;
            console.warn("number of attempts to overcome Api web is necessary to check the configuration file for logger.json");
          }
        }
      }
    }
  }]);

  return LoggerRestClient;
}();

exports.LoggerRestClient = LoggerRestClient;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var bind = __webpack_require__(5);
var Axios = __webpack_require__(16);
var defaults = __webpack_require__(2);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(9);
axios.CancelToken = __webpack_require__(30);
axios.isCancel = __webpack_require__(8);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(31);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var utils = __webpack_require__(0);
var InterceptorManager = __webpack_require__(25);
var dispatchRequest = __webpack_require__(26);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(7);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var transformData = __webpack_require__(27);
var isCancel = __webpack_require__(8);
var defaults = __webpack_require__(2);
var isAbsoluteURL = __webpack_require__(28);
var combineURLs = __webpack_require__(29);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(9);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LoggerConfigurator = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Constants = __webpack_require__(1);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _loadFirst = true;

var LoggerConfigurator = function () {
	function LoggerConfigurator() {
		_classCallCheck(this, LoggerConfigurator);
	}

	_createClass(LoggerConfigurator, null, [{
		key: 'Init',
		value: function Init(callback) {
			if (_loadFirst && LoggerConfigurator.IsConfigurationNotAssigned()) {
				_loadFirst = false;
				LoggerConfigurator.GetByExecutionEnvironment(callback);
			} else {
				callback();
			}
		}
	}, {
		key: 'Setup',
		value: function Setup(configuration, callback) {
			console.info("Setup ", configuration);
			if (configuration) {
				window[_Constants.Constants._LOGGER_VAR_WINDOW] = {};

				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = Object.entries(_Constants.Constants._CONFIGURATIONS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var _step$value = _slicedToArray(_step.value, 2),
						    key = _step$value[0],
						    value = _step$value[1];

						setValueDefatult(configuration, key, value);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				Object.keys(configuration).forEach(function (key) {
					return window[_Constants.Constants._LOGGER_VAR_WINDOW][key] = configuration[key];
				});

				if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN) {
					LoggerConfigurator.SetConfigurationServer();
				}
			} else {
				window[_Constants.Constants._LOGGER_VAR_WINDOW] = _Constants.Constants._CONFIGURATIONS;
				console.info('Logger will use default configuration ... ', _Constants.Constants._CONFIGURATIONS);
			}
			callback();
		}
	}, {
		key: 'GetByExecutionEnvironment',
		value: function GetByExecutionEnvironment(callback) {
			if (LoggerConfigurator.IsBrowser()) {
				LoggerConfigurator.GetRemote(callback);
			} else {
				LoggerConfigurator.GetLocal(callback);
			}
		}
	}, {
		key: 'IsBrowser',
		value: function IsBrowser() {
			return window ? true : false;
		}
	}, {
		key: 'GetLocal',
		value: function GetLocal(callback) {
			LoggerConfigurator.Setup(null, callback);
		}
	}, {
		key: 'GetRemote',
		value: function GetRemote(callback) {
			var remoteLocation = window.location + "";
			var remoteSplit = remoteLocation.split('/');
			remoteLocation = remoteLocation.replace(remoteSplit[remoteSplit.length - 1], '');
			remoteLocation = remoteLocation + _Constants.Constants._LOGGER_CONFIGURATION_FILE_REMOTE;

			_axios2.default.get(remoteLocation, { responseType: 'json' }).then(function (response) {
				LoggerConfigurator.Setup(response.data, callback);
			}).catch(function (error) {
				console.error("It was not possible to get remote file configuration", error);
				LoggerConfigurator.Setup(null, callback);
			});
		}
	}, {
		key: 'SetConfigurationServer',
		value: function SetConfigurationServer() {
			if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN) {
				var hostname = window.location.hostname;
				if (hostname !== "127.0.0.1" && hostname !== "localhost") {
					var remoteLocation = window.location.origin;
					console.debug("SetConfigurationServer withLocation", remoteLocation);
					window[_Constants.Constants._LOGGER_VAR_WINDOW]["_SERVER"] = remoteLocation;
				}
			}
		}
	}, {
		key: 'ExistExternalConfiguration',
		value: function ExistExternalConfiguration(configuration) {
			return configuration ? true : false;
		}
	}, {
		key: 'IsConfigurationNotAssigned',
		value: function IsConfigurationNotAssigned() {
			return !_Constants.Constants._LOGGER_CONFIGURATION_ASSIGNED;
		}
	}]);

	return LoggerConfigurator;
}();

function setValueDefatult(configuration, property, valueDefault) {
	if (configuration[property] === undefined) {
		console.info("file logger.json does not contain field [%s] set value default [%s]", property, valueDefault);
		configuration[property] = valueDefault;
	}
}

exports.LoggerConfigurator = LoggerConfigurator;

/***/ })
/******/ ]);
});
//# sourceMappingURL=global-logger-services-js-bundle.js.map 

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URLClient = exports.URLClient = function () {
  function URLClient(urlWrapper) {
    _classCallCheck(this, URLClient);

    this.urlWrapper = urlWrapper;
  }

  _createClass(URLClient, [{
    key: "getQueryVariable",
    value: function getQueryVariable(variable) {
      var query = this.urlWrapper.getURLQueryParameters();
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }, {
    key: "updateQueryStringParameter",
    value: function updateQueryStringParameter(key, value) {
      var uri = this.urlWrapper.getURLString();
      var newUri = "";
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = uri.indexOf('?') !== -1 ? "&" : "?";
      if (uri.match(re)) {
        newUri = uri.replace(re, '$1' + key + "=" + value + '$2');
      } else {
        newUri = uri + separator + key + "=" + value;
      }
      this.urlWrapper.setURL(newUri);
    }
  }]);

  return URLClient;
}();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URLWrapper = exports.URLWrapper = function () {
  function URLWrapper() {
    _classCallCheck(this, URLWrapper);
  }

  _createClass(URLWrapper, [{
    key: "getURL",
    value: function getURL() {
      return window.location;
    }
  }, {
    key: "getURLString",
    value: function getURLString() {
      return this.getURL().href;
    }
  }, {
    key: "getURLQueryParameters",
    value: function getURLQueryParameters() {
      return this.getURL().search.substring(1);
    }
  }, {
    key: "setURL",
    value: function setURL(url) {
      window.location.href = url;
    }
  }]);

  return URLWrapper;
}();

/***/ })
/******/ ]);
});
//# sourceMappingURL=global-common-utilities-js-bundle.js.map 


//////////////////
// WEBPACK FOOTER
// ./~/global-common-utilities-js/global-common-utilities-js-bundle.js
// module id = 688
// module chunks = 0